export const name = 'gzFormContent';

/**
 * @ngdoc directive
 * @name gazelle.components.formContent.directive:gzFormContent
 *
 * @param {boolean} submitting flag to indicate the form is currently being submitted.
 *    When true, the form content will be backdropped behind a spinner, visible but unable to edit.
 * @param {boolean} no-content (optional) flag to indicate the form is empty and shouldn't display empty content.
 *
 * @description
 * `<gz-form-content>` wraps form content to allow for a consistent approach following the
 * [Behaviors-Errors-Validation mockups](https://hp.sharepoint.com/teams/GSBCTO/Shared%20Documents/Programs/Genesis/User%20Experience/Shared/Behaviors-Errors-Validation.pdf).
 * In particular, when a form is being submitted (as indicated by the `submitting` parameter),
 * the form is backdropped behind a spinner and is visible but not editable.
 *
 * @example
 * ```html
   <form name="vm.form" ng-submit="vm.submit()">
     <!-- Will display any submission errors at the top -->
     <gz-error-bar error-key="vm.errorMessageKey"></gz-error-bar>

     <!-- Scrolling form content with spinner during submission -->
     <gz-form-content>
       <md-input-container>
         <label for="userName" translate="UserName"></label>
         <input id="userName" name="userName" ng-model="vm.user.name" required>
       </md-input-container>
     </gz-form-content>

     <!-- Form action buttons -->
     <div class="md-actions" layout="row">
       <md-button class="md-primary" type="button" ng-click="vm.cancel()" translate="Cancel"></md-button>
       <md-button class="md-primary md-raised" type="submit" translate="Submit"></md-button>
     </div>
   </form>
 * ```
 **/
export default function gzFormContent() {
  'ngInject';

  var directive = {
    restrict: 'EA',
    scope: {
      submitting: '=',
      noContent: '=?'
    },
    template: require('./form-content.jade'),
    transclude: true,
    controllerAs: 'vm',
    bindToController: true,
    controller: gzFormContentController,
  };

  return directive;

  /////////////////

  function gzFormContentController() {

  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/form-content/form-content.directive.js